// Mock data for Blissfull Mobile Spa

export const contactInfo = {
  whatsapp: '0824865144',
  whatsappIntl: '27824865144',
  email: 'blissfulmobilespa@justionos.com',
  location: 'Cape Town, South Africa',
  brandLogoUrl:
    'https://customer-assets-wrfwihn1.emergentagent.net/job_blissful-spa-rebuild/artifacts/cljepur2_WhatsApp%20Image%202026-07-27%20at%2020.07.4912.jpeg',
};

export const testimonials = [
  {
    id: 1,
    text: "Treatment was absolutely amazing. My therapist Dawn is a gem. She is very knowledgeable and so friendly.",
    stars: 5,
  },
  {
    id: 2,
    text: "Dawn was absolutely amazing, best massage I have ever had! Thanks Dawn!",
    stars: 5,
  },
  {
    id: 3,
    text: "My massage with Dawn was exceptional. I've been for many massages in my life but she is truely gifted. I was quite blown away with the facial.",
    stars: 5,
  },
];

export const midTestimonials = [
  {
    id: 4,
    text: "Best massage ever. Dawn is one of the most amazing, caring massage therapists! She made me feel like she really wants to put me and my body first and at no stage did I feel like I was 'just another client'. I will certainly be back!!",
    stars: 5,
  },
  {
    id: 5,
    text: "Dawn dispatches her work professionally, is a lovely young lady to talk to, and an all-round nice person.",
    stars: 5,
  },
  {
    id: 6,
    text: "The attention to detail from the colour light therapy to the heated blanket and booties was excellent. On top of that, Dawn is an amazing therapist. Lots of positive energy, great personnality and excellent at what she does :) (this is from an ex therapist).",
    stars: 5,
  },
  {
    id: 7,
    text: "Dawn was polite and friendly, her hands did wonders, will definitely be back for more.",
    stars: 5,
  },
  {
    id: 8,
    text: "Dawn was lovely warm and well experienced, would love to see her again. Overall amazing experience when I revisit Cape Town. Will definitely be on my to do list.",
    stars: 5,
  },
];

export const pricingCategories = [
  {
    id: 'bliss-45',
    duration: '45 MIN',
    emoji: '\u2728',
    title: 'Bliss Massage',
    subtitle: 'THE UTTER BLISS',
    services: [
      { name: 'Foot ritual', price: 'R680' },
      { name: 'Back, neck & shoulder', price: 'R789' },
      { name: 'Indian head', price: 'R800' },
    ],
  },
  {
    id: 'timeout-60',
    duration: '60 MIN',
    emoji: '\ud83d\udca4',
    title: 'Total Time Out',
    subtitle: 'THE TOTAL TIMEOUT',
    services: [
      { name: 'Back of body', price: 'R850' },
      { name: 'Swedish massage', price: 'R890' },
      { name: 'Detox massage', price: 'R950' },
      { name: 'Deep tissue massage', price: 'R1100' },
      { name: 'Mom-to-be massage', price: 'R1100' },
    ],
  },
  {
    id: 'escape-90',
    duration: '90 MIN',
    emoji: '\u2708\ufe0f',
    title: 'Full Escapes',
    subtitle: 'THE FULL ESCAPE',
    services: [
      { name: 'Blissful signature massage', price: 'R1350' },
      { name: 'Cupping', price: 'R1200' },
      { name: 'Deep tissue massage', price: 'R1400' },
      { name: 'Sports massage', price: 'R1480' },
      { name: 'Mom-to-be massage', price: 'R1300' },
    ],
  },
  {
    id: 'happy-feet',
    duration: '60 MIN',
    emoji: '\ud83d\udc63',
    title: 'Happy Feet',
    subtitle: 'MANI & PEDI',
    services: [
      { name: 'Express pedicure', price: 'R560' },
      { name: 'Express manicure', price: 'R550' },
      { name: 'Classic pedicure', price: 'R660' },
      { name: 'Classic manicure', price: 'R640' },
    ],
  },
  {
    id: 'upsells',
    duration: 'ADD ONS',
    emoji: '\ud83d\udd6f\ufe0f',
    title: 'Massage Upsells',
    subtitle: 'ELEVATE YOUR TREATMENT',
    services: [
      { name: 'Cupping', price: 'R300' },
      { name: 'Lava shells', price: 'R450' },
    ],
  },
  {
    id: 'oils',
    duration: 'ADD ONS',
    emoji: '\ud83c\udf3f',
    title: 'Personalised Oils',
    subtitle: 'BLENDED FOR YOU',
    services: [
      { name: 'Body mechanic', price: 'R250' },
      { name: 'CBD', price: 'R250' },
      { name: 'Magnesium', price: 'R250' },
    ],
  },
];

// Gallery: real spa photos only (brand logo card + back massage + foot ritual removed)
export const galleryImages = [
  { url: 'https://customer-assets-wrfwihn1.emergentagent.net/job_blissful-spa-rebuild/artifacts/qfwp9hhk_WhatsApp%20Image%202026-07-27%20at%2020.07.483.jpeg', alt: 'Bellabaci oils with tea lights' },
  { url: 'https://customer-assets-wrfwihn1.emergentagent.net/job_blissful-spa-rebuild/artifacts/tmc9n2su_WhatsApp%20Image%202026-07-27%20at%2020.07.482.jpeg', alt: 'Shoulder massage with warm oil' },
  { url: 'https://customer-assets-wrfwihn1.emergentagent.net/job_blissful-spa-rebuild/artifacts/cktpvs9r_WhatsApp%20Image%202026-07-27%20at%2020.07.49.jpeg', alt: 'Blissfull mobile spa table setup' },
  { url: 'https://customer-assets-wrfwihn1.emergentagent.net/job_blissful-spa-rebuild/artifacts/30xfwmvz_WhatsApp%20Image%202026-07-27%20at%2020.07.499.jpeg', alt: 'Bellabaci CBD & body oil trio' },
  { url: 'https://customer-assets-wrfwihn1.emergentagent.net/job_blissful-spa-rebuild/artifacts/lp5tx3v7_WhatsApp%20Image%202026-07-27%20at%2020.07.498.jpeg', alt: 'Soothing spa candlelight' },
];

export const aboutImage1 = 'https://customer-assets-wrfwihn1.emergentagent.net/job_blissful-spa-rebuild/artifacts/tmc9n2su_WhatsApp%20Image%202026-07-27%20at%2020.07.482.jpeg';
export const aboutImage2 = 'https://customer-assets-wrfwihn1.emergentagent.net/job_blissful-spa-rebuild/artifacts/lp5tx3v7_WhatsApp%20Image%202026-07-27%20at%2020.07.498.jpeg';
export const contactImage = 'https://customer-assets-wrfwihn1.emergentagent.net/job_blissful-spa-rebuild/artifacts/cktpvs9r_WhatsApp%20Image%202026-07-27%20at%2020.07.49.jpeg';
